import Vue from 'vue'
import loginBg from './login-bg.svg'
import loginBgDark from './login-bg-dark.svg'

Vue.component('login-bg',loginBg)
Vue.component('login-bg-dark',loginBgDark)
